import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs'
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'

import { HelperService } from './helper.service'

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private progressBarHidden: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)
  public progressBarHidden$: Observable<boolean> = this.progressBarHidden.asObservable()
  private progressBarCounter: number = 0
  public isHandset$: Observable<boolean>

  constructor(
    private helper: HelperService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset)
      .pipe(
        map(result => result.matches),
        shareReplay()
      )
  }

  async toggleProgressBarOn() {
    await this.helper.delay(0)
    this.progressBarCounter++
    this.progressBarHidden.next(false)
  }

  async toggleProgressBarOff() {
    await this.helper.delay(500)
    this.progressBarCounter--
    if (this.progressBarCounter < 0)
      this.progressBarCounter = 0
    this.progressBarHidden.next(this.progressBarCounter <= 0)
  }
}
